import createReducer from 'utils/createReducer';
import {
  UPDATE_ADDON_PRODUCTS,
  SET_ADDON_PRODUCTS_LOADING,
  SHOW_EDIT_PRICE_MODAL,
  SET_PRICE_EDITOR_LOADING,
  SET_PRICE_EDITOR_ERROR,
  ADDITIONAL_SERVICE_LOG_SET_SHOWN,
  ADDITIONAL_SERVICE_LOG_SET_DATA,
  ADDITIONAL_SERVICE_LOG_SET_IS_LOADING,
  ADDITIONAL_SERVICE_LOG_SET_ERRORS,
} from './actionTypes';

const initialState = {
  products: [],
  isLoading: false,
  priceEditor: {
    isOpen: false,
    editingProduct: null,
    isLoading: false,
    errorMessage: null,
  },
  log: {
    shown: false,
    isLoading: false,
    data: [],
    paging: {
      page: 1,
      size: 20,
      total: 0,
    },
    errors: [],
  },
};

const updateAddonProducts = (state, action) => ({
  ...state,
  products: action.payload,
});

const setAddonProductsLoading = (state, action) => ({
  ...state,
  isLoading: action.payload,
});

const showEditPriceModal = (state, action) => ({
  ...state,
  priceEditor: {
    ...state.priceEditor,
    isOpen: action.payload.shown,
    editingProduct: action.payload.product,
    errorMessage: null,
  },
});

const setPriceEditorLoading = (state, action) => ({
  ...state,
  priceEditor: {
    ...state.priceEditor,
    isLoading: action.payload,
  },
});

const setPriceEditorError = (state, action) => ({
  ...state,
  priceEditor: {
    ...state.priceEditor,
    errorMessage: action.payload,
  },
});

const setLogModalShown = (state, action) => ({
  ...state,
  log: {
    ...state.log,
    shown: action.payload.shown,
  },
});

const setLogData = (state, action) => ({
  ...state,
  log: {
    ...state.log,
    data: action.payload.data,
    paging: action.payload.paging,
  },
});

const setLogIsLoading = (state, action) => ({
  ...state,
  log: {
    ...state.log,
    isLoading: action.payload.isLoading,
  },
});

const setLogErrors = (state, action) => ({
  ...state,
  log: {
    ...state.log,
    errors: action.payload.errors,
  },
});

export default createReducer(initialState, {
  [UPDATE_ADDON_PRODUCTS]: updateAddonProducts,
  [SET_ADDON_PRODUCTS_LOADING]: setAddonProductsLoading,
  [SHOW_EDIT_PRICE_MODAL]: showEditPriceModal,
  [SET_PRICE_EDITOR_LOADING]: setPriceEditorLoading,
  [SET_PRICE_EDITOR_ERROR]: setPriceEditorError,
  [ADDITIONAL_SERVICE_LOG_SET_SHOWN]: setLogModalShown,
  [ADDITIONAL_SERVICE_LOG_SET_DATA]: setLogData,
  [ADDITIONAL_SERVICE_LOG_SET_IS_LOADING]: setLogIsLoading,
  [ADDITIONAL_SERVICE_LOG_SET_ERRORS]: setLogErrors,
});
